import { api } from '../client';

export interface Supplier {
  id: string;
  name: string;
  code: string;
  contactName?: string;
  email?: string;
  phone?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
  };
  rating?: number;
  isActive: boolean;
  _count?: { purchaseOrders: number };
  createdAt: string;
  updatedAt: string;
}

export interface CreateSupplierDto {
  name: string;
  code: string;
  contactName?: string;
  email?: string;
  phone?: string;
  address?: Supplier['address'];
  rating?: number;
  isActive?: boolean;
}

export interface QuerySupplierParams {
  search?: string;
  isActive?: boolean;
  page?: number;
  limit?: number;
}

export interface SupplierPerformance {
  supplierId: string;
  supplierName: string;
  metrics: {
    totalOrders: number;
    totalValue: number;
    onTimeDeliveryRate: number;
    fulfillmentRate: number;
    currentRating?: number;
  };
}

export const suppliersApi = {
  async getAll(params?: QuerySupplierParams) {
    const response = await api.get<{
      data: Supplier[];
      meta: { total: number; page: number; limit: number; totalPages: number };
    }>('/api/suppliers', { params });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<Supplier>(`/api/suppliers/${id}`);
    return response.data;
  },

  async getPurchaseOrders(id: string, params?: { page?: number; limit?: number }) {
    const response = await api.get(`/api/suppliers/${id}/purchase-orders`, { params });
    return response.data;
  },

  async getPerformance(id: string) {
    const response = await api.get<SupplierPerformance>(`/api/suppliers/${id}/performance`);
    return response.data;
  },

  async create(data: CreateSupplierDto) {
    const response = await api.post<Supplier>('/api/suppliers', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateSupplierDto>) {
    const response = await api.patch<Supplier>(`/api/suppliers/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete<Supplier>(`/api/suppliers/${id}`);
    return response.data;
  },
};
